import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { translations } from '../translations';

const { FiPlay, FiSettings, FiMonitor, FiMousePointer, FiX, FiHelpCircle } = FiIcons;

function Guide({ isOpen, onClose, language }) {
  const t = translations[language] || translations.en;

  if (!isOpen) return null;

  const steps = [
    {
      icon: FiPlay,
      title: t.guide.step1Title,
      desc: t.guide.step1Desc,
      color: 'bg-pink-500',
    },
    {
      icon: FiSettings,
      title: t.guide.step2Title,
      desc: t.guide.step2Desc,
      color: 'bg-purple-500',
    },
    {
      icon: FiMonitor,
      title: t.guide.step3Title,
      desc: t.guide.step3Desc,
      color: 'bg-blue-500',
    },
    {
      icon: FiMousePointer,
      title: t.guide.step4Title,
      desc: t.guide.step4Desc,
      color: 'bg-green-500',
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        className="bg-[#1a1b2e] rounded-3xl w-full max-w-3xl overflow-hidden shadow-2xl border border-white/10"
      >
        {/* Header */}
        <div className="p-6 border-b border-white/10 flex justify-between items-center bg-white/5">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-indigo-500/20 rounded-lg">
              <SafeIcon icon={FiHelpCircle} className="text-2xl text-indigo-400" />
            </div>
            <h2 className="text-2xl font-bold text-white tracking-tight">{t.howToUse}</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/10 rounded-full transition-colors group"
          >
            <SafeIcon icon={FiX} className="text-xl text-white/60 group-hover:text-white" />
          </button>
        </div>

        {/* Content */}
        <div className="p-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="flex gap-4 p-4 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-white/20 transition-all"
            >
              <div className={`w-12 h-12 rounded-xl ${step.color} flex items-center justify-center shrink-0 shadow-lg`}>
                <SafeIcon icon={step.icon} className="text-2xl text-white" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-white mb-1">{step.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-white/10 bg-white/5 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-white text-black rounded-full font-bold hover:bg-gray-200 transition-all shadow-lg active:scale-95"
          >
            {t.close}
          </button>
        </div>
      </motion.div>
    </div>
  );
}

export default Guide;